const activeRecordPermissionProviderRegistrations = {}

const getModelKey = Model => Model?.tableName

const getModelLabel = Model => getModelKey(Model) || Model?.name

/**
 * Registers the permission provider hook for an ActiveRecord model.
 *
 * The model's `tableName` is used as the registry key. The provider hook is invoked
 * later by `useActiveRecordPermissions`.
 */
export const registerActiveRecordPermissions = (Model, usePermissionsProvider) => {
	const modelKey = getModelKey(Model)

	if (!modelKey) {
		throw new Error(`Cannot register ActiveRecord permissions without a model tableName (received ${getModelLabel(Model)}).`)
	}

	if (typeof usePermissionsProvider !== 'function') {
		throw new Error(`Cannot register ActiveRecord permissions for ${modelKey} without a provider hook.`)
	}

	activeRecordPermissionProviderRegistrations[modelKey] = usePermissionsProvider
}

/**
 * Returns the registered permission provider for an ActiveRecord model.
 *
 * This invokes the provider hook for the model, so callers should use it like any
 * other React hook.
 */
export const useActiveRecordPermissions = Model => {
	const modelKey = getModelKey(Model)
	const usePermissionsProvider = activeRecordPermissionProviderRegistrations[modelKey]

	if (!usePermissionsProvider) {
		throw new Error(`No ActiveRecord permission provider registered for ${getModelLabel(Model)}.`)
	}

	return usePermissionsProvider()
}
